export const useAuth = () => {
  const {
    currentUser,
    isLoading,
    refetch: refetchSelfUser,
    isError,
  } = useCurrentUser()

  const isLoggedIn = computed(() => !!currentUser.value)

  return {
    isLoggedIn,
    isLoadingAuthStatus: isLoading,
    permissions: computed(
      () => currentUser.value?.permissions || []
    ),
    hasRetrieveSelfUserFailed: isError,
    refetchSelfUser,
  }
}
